import { SyntheticEvent, useEffect, useState } from 'react';
import { Avatar, Button, Container, makeStyles, TextField, Typography, Box } from '@material-ui/core';
import { LockOutlined } from '@material-ui/icons';
import { auth } from '../../core/services';
import { useAppContext } from '../../core/contexts';
import { useQueryClient } from 'react-query';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const useStyles = makeStyles((theme) => ({
    paper: {
        paddingTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

interface Form {
    mail: string;
    password: string;
    idSousWeb: string;
}

export default function SigninBackOffice() {
    const { setToken, setAppLoading } = useAppContext();
    const classes = useStyles();
    const [form, setForm] = useState<Form>({ mail: '', password: '', idSousWeb: '' });
    const queryClient = useQueryClient();
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const id = queryParams.get('id');

    useEffect(() => {
        const idSousWeb = id ? id.replace(/^(app-|APP-)/, '') : '';
        setField('idSousWeb', idSousWeb);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => setAppLoading(false), [setAppLoading]);

    const setField = (name: 'mail' | 'password' | 'idSousWeb', value: string) => setForm({ ...form, [name]: value });

    const handleSubmit = (e: SyntheticEvent) => {
        e.preventDefault();
        setAppLoading(true);
        auth.authenticate(form.mail, form.password, form.idSousWeb)
            .then(async ({ token }) => {
                // Reset token
                await queryClient.removeQueries();
                await queryClient.clear();
                setToken(token);
            })
            .catch((error) => {
                if (error?.response?.data?.message === 'Souscrip Web not found !') {
                    toast.error('Souscripteur web non trouvé !');
                }
            })
            .finally(() => setAppLoading(false));
    };

    return (
        <>
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlined />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Se connecter - Interne
                    </Typography>
                    <Box className="mt-2 mb-2">Pour vous connecter, veuillez utiliser vos identifiants AGEO habituels et renseigner l'identifiant du souscripteur</Box>
                    <form className={classes.form} onSubmit={handleSubmit}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            //type="email"
                            type="text"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            value={form.mail}
                            onChange={(e) => setField('mail', e.target.value)}
                            autoFocus
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Mot de passe"
                            type="password"
                            id="password"
                            value={form.password}
                            onChange={(e) => setField('password', e.target.value)}
                            autoComplete="current-password"
                        />
                        <Box className="mt-3">
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="idSousWeb"
                                label="Identifiant souscripteur"
                                type="text"
                                id="idSousWeb"
                                value={form.idSousWeb}
                                onChange={(e) => setField('idSousWeb', e.target.value)}
                            />
                        </Box>

                        <Button fullWidth type="submit" variant="contained" color="primary" className={classes.submit} name={'Se connecter'}>
                            Se connecter
                        </Button>
                    </form>
                </div>
            </Container>
        </>
    );
}
